'use strict';

/**
* FUNCTION: defaults()
*	Returns default options.
*
* @returns {Object} default options
*/
function defaults() {
	return {
		'sep': '.'
	};
} // end FUNCTION defaults()


// EXPORTS //

module.exports = defaults;
